<template>
    <div class="widget-period-switcher">
        <span v-for="item in options" v-if="item.id == internalValue">{{ item.label }}</span>
        <i class="icon icon-icon_arrow-down"></i>
        <ul>
            <li v-for="item in options" @click="selectValue(item.id)" v-bind:class="{'active':item.id==internalValue}"><span>{{ item.label }}</span></li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'FormField',
        props: ['value','options','callback'],
        data: function () {
            return {
                internalValue: '',
                langClass:""
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.onChange = this.callback ? true : false;
        },
        methods: {
            selectValue: function(val){
                this.internalValue = val
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                let val = this.internalValue
                val = newVal
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
                if( this.onChange ){
                    this.callback(this.internalValue)
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/WidgetDropdown.vue